import { render } from "./delete-filter.vue?vue&type=template&id=6a54f784"
import script from "./delete-filter.vue?vue&type=script&lang=js"
export * from "./delete-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__